// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { IPermissions } from "@/types/keycloak";
import { SIGNING_ACTIONS } from "@/lib/signing/types";
/**
 * Which of a role's permissions the user may turn on or off in Users and Roles. Harvest's
 * `RolePermissionEdit` enforces the same: `role-write` alone changes only who can sign.
 */
export var RolePermissionEdit;
(function (RolePermissionEdit) {
    RolePermissionEdit["AnyPermission"] = "any-permission";
    RolePermissionEdit["SignPermissions"] = "sign-permissions";
    RolePermissionEdit["ReadOnly"] = "read-only";
})(RolePermissionEdit || (RolePermissionEdit = {}));
var SIGN_PERMISSIONS = new Set(Object.values(SIGNING_ACTIONS).map(function (action) { return action.signPermission; }));
export var rolePermissionEdit = function (holds) {
    if (!holds(IPermissions.ROLE_WRITE)) {
        return RolePermissionEdit.ReadOnly;
    }
    return holds(IPermissions.USER_PERMISSION_WRITE)
        ? RolePermissionEdit.AnyPermission
        : RolePermissionEdit.SignPermissions;
};
export var canEditRolePermission = function (edit, permissionName) {
    return edit === RolePermissionEdit.AnyPermission ||
        (edit === RolePermissionEdit.SignPermissions && SIGN_PERMISSIONS.has(permissionName));
};
